import { render, staticRenderFns } from "./TravelFeedbackCancelledSection.vue?vue&type=template&id=4c6567f8&scoped=true&"
import script from "./TravelFeedbackCancelledSection.vue?vue&type=script&lang=js&"
export * from "./TravelFeedbackCancelledSection.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/travel_rate_job_tab.css?vue&type=style&index=0&id=4c6567f8&prod&scoped=true&lang=css&"
import style1 from "./TravelFeedbackCancelledSection.vue?vue&type=style&index=1&id=4c6567f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6567f8",
  null
  
)

export default component.exports